import React from 'react'
import styled from 'styled-components'

import logoText from '../../../assets/images/logo_text.jpg'
import CoyIcon from '../../../assets/images/coy_logo.png'

interface LogoProps {
  isDark: boolean
}
const Logo: React.FC<LogoProps> = ({ isDark }) => {
  return (
    <StyledLogo>
      <img style={{ borderRadius: '50%' }} src={CoyIcon} alt="text" className="text" />
      &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
    </StyledLogo>
  )
}

const StyledLogo = styled.div`
  align-items: center;
  display: flex;
  justify-content: center;
  margin: 0;
  padding: 0;
  text-decoration: none;
  img {
    width: 30px;
  }
  .text {
    margin-left: 6px;
    height: 35px;
    width: auto;
  }
  @media (max-width: 900px) {
    .text {
      height: auto;
      max-height: 35px;
    }
  }
`

export default Logo
